import { Controller } from "@hotwired/stimulus";

export default class AsyncController extends Controller {
  connect() {
    this.abortController = new AbortController();
    this.element.showModal();

    this.element.addEventListener('click', this.#closeOnBackdropClick.bind(this), {
      signal: this.abortController.signal
    });

    this.element.addEventListener('close', this.close.bind(this), {
      signal: this.abortController.signal
    });
  }

  disconnect() {
    this.abortController.abort();
    this.close();
  }

  close() {
    try {
      this.element.close()
      this.constructor.turboFrame.src = null
      this.element.remove()
    } catch {
      // do nothing
    }
  }

  #closeOnBackdropClick(event) {
    if (event.target === this.element) {
      this.close();
    }
  }

  static get turboFrame() {
    return document.querySelector('turbo-frame#modal')
  }
}
